import React from "react";

const IconArrowRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={16}
      viewBox="0 0 21 16"
      fill="none"
      {...props}
    >
      <path
        d="M20.5391 8.70711C20.9297 8.31658 20.9297 7.68342 20.5391 7.2929L14.1752 0.928933C13.7847 0.538409 13.1515 0.538409 12.761 0.928933C12.3704 1.31946 12.3704 1.95262 12.761 2.34315L18.4178 8L12.761 13.6569C12.3704 14.0474 12.3704 14.6805 12.761 15.0711C13.1515 15.4616 13.7847 15.4616 14.1752 15.0711L20.5391 8.70711ZM0 8L-8.74228e-08 9L19.832 9L19.832 8L19.832 7L8.74228e-08 7L0 8Z"
        // fill="white"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconArrowRight;
